import PlusCircle from 'assets/icons/PlusCircle';
import COLOR from 'constants/color';

interface InsertionIndicatorProps {
  visible?: boolean;
  className?: string;
  onClick?: () => void;
}

const InsertionIndicator = ({
  visible = false,
  className = '',
  onClick
}: InsertionIndicatorProps) => {
  if (!visible) {
    return null;
  }

  return (
    <div
      className={`w-full h-px relative flex items-center transition-all duration-200 ease-in-out ${
        visible ? 'opacity-100' : 'opacity-0 pointer-events-none'
      } ${className}`}
      onClick={onClick}
      role='button'
      tabIndex={visible ? 0 : -1}
      aria-label='Insert new habit here'
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <div className='w-full h-px bg-primary-500' />
      <div className='absolute left-0 flex items-center justify-center ~w-5/10 ~h-5/10 rounded-full bg-white dark:bg-secondary-dark-300 border-2 border-primary-500 shadow-sm -translate-x-1/2 cursor-pointer hover:scale-110 transition-transform duration-200 z-10'>
        <PlusCircle
          styles='~w-3/5 ~h-3/5'
          fill={COLOR.PRIMARY.LIGHT_900}
          fillDarkMode={COLOR.PRIMARY.DARK_500}
        />
      </div>
    </div>
  );
};

export default InsertionIndicator;
